import { Component, OnInit } from '@angular/core';
import { EventoService } from '../../evento/evento.service';
import { Evento } from '../../evento/models/evento';
import { FornecedorService } from '../../fornecedor/fornecedor.service';
import { Fornecedor } from '../../fornecedor/models/fornecedor';
import  {ParametrizacaoService} from "../parametrizacao.service"
import { Parametro } from '../models/parametrizacao';

import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-parametrizacao',
  templateUrl: './parametrizacao.component.html',
  styleUrls: ['./parametrizacao.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class ParametrizacaoComponent implements OnInit {

  public listEventos: Evento[];
  public listFornecedores: Fornecedor[];
  public listParametros: Parametro[];
  public listTipos: [
    { label: 'Data', value: 'data' },
    { label: 'Texto', value: 'texto' },
    { label: 'Número Inteiro', value: 'inteiro' },
    { label: 'Número Decimal', value: 'decimal' }
  ];

  public Evento: Evento;
  public Fornecedor: Fornecedor;
  public Parametro: Parametro = {} as Parametro;

  public submitted: boolean;
  public displayMsg: boolean = false;
  public displayDialog: boolean;

  constructor(private parametrizacaoService: ParametrizacaoService,
              private fornecedorService: FornecedorService,
              private eventService: EventoService,
              private messageService: MessageService,
              private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.getParametros()
    this.getEventos()
    this.getFornecedores()
    this.listTipos = [
      { label: 'Data', value: 'data' },
      { label: 'Texto', value: 'texto' },
      { label: 'Número Inteiro', value: 'inteiro' },
      { label: 'Número Decimal', value: 'decimal' }
    ];
  }

  reload(){
    this.getParametros()
    this.getEventos()
    this.getFornecedores()
  }
  getEventos() {
    this.eventService.getEventos().subscribe(
      (res) => {
        if (res) {
          this.listEventos = res;           
        }
      },
      err => {
        console.log(err);
      }
    );
  }
  getFornecedores() {
    this.fornecedorService.getFornecedores().subscribe(
      (res) => {
        if (res) {
          this.listFornecedores = res;         
        }
      },
      err => {
        console.log(err);
      }
    );
  }
  getParametros() {
    this.parametrizacaoService.getParametros().subscribe(
      (res) => {
        if (res) {
          this.listParametros = res;         
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getSelectedTipo(tipo: string) {
    try{
      return this.listTipos.find(x => x.value === tipo);
    }catch(ex){
      return {};
    }
  }

  getSelectedEvento(evento: number) {
    try{
      return this.listEventos.find(x => x.idEvento === evento);
    }catch(ex){
      return {};
    }
  }

  getSelectedFornecedor(fornecedor: number) {
    try{
      return this.listFornecedores.find(x => x.idFornecedor === fornecedor);
    }catch(ex){
      return {};
    }
  }
  
  addParametro() {
    this.Parametro = {};
    this.Evento = {};
    this.Fornecedor = {}
    this.submitted = false;
    this.displayDialog = true;
  }

  updParametro(parametro: Parametro) {  
    this.Parametro = parametro;
    this.Evento = this.getSelectedEvento(parametro.idEvento);
    this.Fornecedor = this.getSelectedFornecedor(parametro.idFornecedor);    
    this.displayDialog = true;
  }
  delParametro(parametro: Parametro) {
    this.confirmationService.confirm({
        message: 'Você tem certeza que deseja remover o parametro: ' + parametro.nome + '?',
        header: 'Confirmação',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.parametrizacaoService
            .delParametro(parametro.idParametro)
            .subscribe(                     
                () => this.getParametros(),
                err => console.log(err)
            );
            this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Parametro removido com sucesso!', life: 3000});
        }
    });
  }

  SetEvento(evento)
  {
    this.Parametro.idEvento = evento.idEvento;
  }

  SetFornecedor(fornecedor)
  {
    this.Parametro.idFornecedor = fornecedor.idFornecedor;
  }
  saveParametro() {
    this.submitted = true;      
    if (this.Parametro.nome.trim() && this.Parametro.tipo && this.Parametro.valor) {
        if (this.Parametro.idParametro) {
          
          this.parametrizacaoService
          .updParametro(this.Parametro)
          .subscribe(                     
              () => this.getParametros(),
              err => console.log(err)
          );
            this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Parametro atualizado com sucesso!', life: 3000});
        } else {
            this.parametrizacaoService
                .addParametro(this.Parametro)
                .subscribe(                     
                    () => this.getParametros(),
                    err => 
                    {
                      this.messageService.add({severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações!', life: 3000});
                      console.log(err)
                    }
                );

            this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Parametro cadastrado com sucesso!', life: 3000});
        }

        this.displayDialog = false;
        this.Parametro = {};
    }
  }
  hideDialog() {
    this.displayDialog = false;
    this.submitted = false;  
    this.Evento = {};
    this.Fornecedor = {};
    this.Parametro = {};
  }
}
